import React, { useCallback, useState } from "react";

import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useSavedViews } from "@features/sales-v3/hooks";
import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";
import { TextInput } from "@shared/text-input";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CreateSavedViewsModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const [name, setName] = useState("");
  const { createSavedView } = useSavedViews();
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToasts();

  const saveSavedView = async () => {
    prettyLogEventPage({
      domain: "Top Level Filters",
      action: "onChange",
      additionalActionInfo: "Create Saved View",
    });

    try {
      if (name) {
        setIsSaving(true);
        await createSavedView(name, {
          container: "saved-views-modal",
          eventType: "submit",
        });
        onConfirm();
        toast.addToast("Saved view created", { appearance: "success" });
      }
    } finally {
      setIsSaving(false);
    }
    setName("");
  };

  const cancel = useCallback(() => {
    onCancel();
    setName("");
  }, [onCancel]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={cancel}
      headerTitleProps={{ className: "text-xl font-semibold" }}
      titleContent={<div>Save as new?</div>}
    >
      <TextInput
        label="SAVED VIEW NAME"
        onChange={({ target }) => setName(target.value)}
        value={name}
      />
      <div className="flex space-x-3 mt-12">
        <PrimaryButton
          isDisabled={!name || isSaving}
          loading={isSaving}
          onClick={saveSavedView}
        >
          YES, SAVE
        </PrimaryButton>
        <SecondaryButton disabled={isSaving} onClick={cancel}>
          NO, CANCEL
        </SecondaryButton>
      </div>
    </Modal>
  );
};
